import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, RotateCcw, ArrowRight, Check } from "lucide-react";
import { PHONE, PHONE_LINK, Reveal, Eyebrow } from "../lib/data";

const CONCERNS = [
  { id: "durere", label: "Am o durere de dinți", rec: "Vii la o consultație, aflăm cauza și o rezolvăm." },
  { id: "albire", label: "Vreau un zâmbet mai alb", rec: "Igienizare + albire profesională. Rezultatul se vede din prima ședință." },
  { id: "aliniere", label: "Vreau dinți mai drepți", rec: "Consultație de ortodonție cu simulare — vezi rezultatul înainte să începi." },
  { id: "implant", label: "Îmi lipsește un dinte", rec: "Consultație de implantologie cu CBCT 3D și un plan clar, pas cu pas." },
  { id: "gingii", label: "Îmi sângerează gingiile", rec: "Consultație + igienizare profesională — gingiile se vindecă." },
  { id: "sensibili", label: "Am dinții sensibili", rec: "Aflăm de ce sunt sensibili și îi tratăm." },
  { id: "copil", label: "Vreau să-mi duc copilul la dentist", rec: "Prima vizită e o joacă. Fără durere, fără frică." },
  { id: "frica", label: "Îmi e frică de dentist", rec: "Lucrăm încet, în ritmul tău. Și nu doare." },
];

const Quiz = () => {
  const [selected, setSelected] = useState(null);

  return (
    <section className="py-20 lg:py-28 bg-[#2A2521] relative overflow-hidden" data-testid="quiz-section">
      <div className="absolute inset-0 medical-grid opacity-40" />
      <div className="max-w-3xl mx-auto px-6 relative">
        <Reveal className="text-center">
          <Eyebrow>Evaluare în 10 secunde</Eyebrow>
          <h2 className="font-display text-3xl lg:text-4xl font-bold text-white mt-3">
            Ce te preocupă la zâmbetul tău?
          </h2>
          <p className="text-white/70 mt-4 text-base md:text-lg">
            Alege varianta care ți se potrivește și îți spunem exact cu ce începem.
          </p>
        </Reveal>

        <div className="mt-10 min-h-[260px]">
          <AnimatePresence mode="wait">
            {!selected ? (
              <motion.div
                key="options"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
                className="grid sm:grid-cols-2 gap-3"
                data-testid="quiz-options"
              >
                {CONCERNS.map((c) => (
                  <button
                    key={c.id}
                    onClick={() => setSelected(c)}
                    data-testid={`quiz-option-${c.id}`}
                    className="group text-left bg-white/5 hover:bg-[#A6823B] border border-white/15 hover:border-[#A6823B] rounded-2xl p-5 transition-all hover:-translate-y-0.5"
                  >
                    <span className="font-display font-semibold text-white flex items-center justify-between gap-3">
                      {c.label}
                      <ArrowRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity shrink-0" />
                    </span>
                  </button>
                ))}
              </motion.div>
            ) : (
              <motion.div
                key="result"
                initial={{ opacity: 0, scale: 0.96 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                className="bg-white rounded-2xl p-7 lg:p-8 text-center shadow-2xl"
                data-testid="quiz-result"
              >
                <span className="inline-flex w-12 h-12 rounded-full bg-[#A6823B]/10 items-center justify-center">
                  <Check className="w-6 h-6 text-[#A6823B]" />
                </span>
                <h3 className="font-display text-xl font-bold text-[#2A2521] mt-4">Recomandarea noastră</h3>
                <p className="text-[#6B5C43] mt-2 leading-relaxed">{selected.rec}</p>
                <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
                  <a
                    href={PHONE_LINK}
                    data-testid="quiz-call-button"
                    className="inline-flex items-center justify-center gap-2 bg-[#A6823B] hover:bg-[#8A6B2E] text-white font-semibold px-6 py-3.5 rounded-full transition-colors"
                  >
                    <Phone className="w-4 h-4" /> Sună acum · {PHONE}
                  </a>
                  <button
                    onClick={() => setSelected(null)}
                    data-testid="quiz-restart-button"
                    className="inline-flex items-center justify-center gap-2 bg-[#EFE7D6] hover:bg-[#EADFC6] text-[#A6823B] font-semibold px-6 py-3.5 rounded-full transition-colors"
                  >
                    <RotateCcw className="w-4 h-4" /> Ia-o de la capăt
                  </button>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default Quiz;
